import React from 'react'
import Sheild from '../../../../assets/images/Expressway/sheild.png'
import Bolt from '../../../../assets/images/Expressway/bolt.png'
import Lock from '../../../../assets/images/Expressway/lock.png'
import Mobile from '../../../../assets/images/Expressway/mobile.png'
import Cards from '../../../../assets/images/Expressway/cards.png'
import '../../../../containers/Expressway/expressway.scss'

function ExpresswayBanner() {
  const banner = [
    {
      image: 'lock',
      title: 'Bullet proof 128-bit security',
      desc: 'Complete protection of your card data at all times'
    },
    {
      image: 'sheild',
      title: 'Additional safety precautions',
      desc: 'Does not store your CVV no. or your Verified by Visa / Mastercard 3D-secure details'
    },
    {
      image: 'bolt',
      title: 'Book faster',
      desc: 'When you book travel faster, you also grab cheap prices faster than anyone else.'
    },
    {
      image: 'mobile',
      title: 'Take your cards with you',
      desc: 'Expressway is compatible with Cleartrip mobile.'
    }
  ]

  const getImage = (name = '') => {
    if (name === 'lock') return <img src={Lock} height={50} width={40} alt="card" />
    if (name === 'sheild') return <img src={Sheild} height={45} width={40} alt="card" />
    if (name === 'bolt') return <img src={Bolt} height={40} width={32} alt="card" />
    if (name === 'mobile') return <img src={Mobile} height={50} width={32} alt="card" />
    if (name === 'cards') return <img src={Cards} height={32} width={32} alt="card" />
  }
  return (
    <div className="p-5">
      {
        banner.map(item => (
          <div className="flex flex-start ewBanner">
            <span className="wMin-60">{getImage(item.image)}</span>
            <span>
              <div className="ewBannerHeading">{item.title}</div>
              <div className="ewBannerDesc">{item.desc}</div>
            </span>
          </div>
        ))
      }
      <div className="ewSeparator" />
      <img src={Cards} className="ewCardsBannerImg" alt="card" />
      <div className="ewSeparator" />
    </div>
  )
}

export default ExpresswayBanner
